var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.ie())?_c('IE'):_c('StoreHasEcommerceFeatureEnabled')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }